import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
export const DragAndDropProvider = ({ children, }) => {
    return _jsx(DndProvider, { backend: HTML5Backend, children: children });
};
